import {AbstractService} from 'services/AbstractService';


const USER_BALANCE_URL = '/api/aori/userbalance';
const AVAILABLE_PAYMENT_METHODS = '/api/aori/payment/options';
const PAYMENT_URL = '/api/aori/payment/url';
const BUDGET_URL = '/api/aori/budget';
const TRANSACTION_TYPES_URL = 'api/aori/repos/transactiontypes';
const PAYMENT_HISTORY_URL = 'api/aori/payment/history';

export class AoriService extends AbstractService {
  async getUserBalance (accountId) {
    return (await this.client.get(USER_BALANCE_URL, {}, {accountId})).data;
  }

  async getAvailablePaymentMethods (accountId) {
    return await this.client.get(AVAILABLE_PAYMENT_METHODS, {}, {accountId});
  }

  async getPaymentUrl (payload) {
    return (await this.client.get(PAYMENT_URL, {
      method: payload.method,
      sum: payload.sum,
      back_url: payload.back_url
    }, {accountId: payload.accountId})).data;
  }

  async getBudget (accountId) {
    return (await this.client.get(BUDGET_URL, {}, {accountId})).items;
  }

  async changeChannelBudget (payload) {
    return (await this.client.put(BUDGET_URL,
      {
        amount: payload.amount,
        channel_id: payload.channelId
      },
      {accountId: payload.accountId})).data;
  }

  async getTransactionTypes (accountId) {
    return await this.client.get(TRANSACTION_TYPES_URL, {}, {accountId});
  }

  async getPaymentHistory (payload) {
    return (await this.client.get(PAYMENT_HISTORY_URL, {
      payment_type: payload.payment_type,
      date_from: payload.date_from,
      date_to: payload.date_to,
      sorting: payload.sorting
    }, {accountId: payload.accountId})).data;
  }
}

